// @flow

import * as React from 'react';
import { Query } from 'react-apollo';

import type { Actions } from '../../../types';
import Row from '../../../components/Row';
import ActionsColumn from '../../../components/ActionsHeaderColumn';
import Separator from '../../../components/Separator';
import StateSelectorAction from '../../../components/actions/StateSelectorAction';
import MonthSelectorAction from '../../../components/actions/MonthSelectorAction';
import InventoryNotesAction from '../../../components/actions/InventoryNotesAction';
import InventoryReviewsAction from '../../../components/actions/InventoryReviewsAction';
import getActiveOrderQuery from '../../../graphql/queries/getActiveOrder.query';
import { emitter } from '../../../utils';
import AddInventoryToOrderAction from "../../../components/actions/AddInventoryToOrderAction";
import ClearFiltersAction from '../../../components/actions/ClearFiltersAction'
import { DesktopView, MobileView } from '../../../config/mediaQuery';

type Props = {
  minHeight: string,
  onItemUpdated: any => mixed,
  selectedOrderType?: string,
  selectedOrderDate?: string,
  displayRowMenu: Boolean,
  displayMenu: Boolean,
};

const ActionsOrganizerAccounts = (props: Actions & Props) => {
  const {
    ColumnsAction,
    CopyAction,
    ExportAction,
    RefreshAction,
    SaveViewAction,
    MultiSortAction,
    FieldViewerAction,
    hasDataToDisplay,
    loading,
    currentItem,
    getGlobalDisabledState,
    isOneRowSelected,
    moduleName,
    onItemAdded,
    itemAddedStatus,
    onItemUpdated,
    selectedOrderType,
    selectedOrderDate,
    moduleRefetch,
    clearInternalFilters,
    displayRowMenu,
    displayMenu
  } = props;

  const restrictions = FieldViewerAction({ field: 'Restrictions' });
  const notes = <InventoryNotesAction
    disabled={
      getGlobalDisabledState() ||
      !hasDataToDisplay ||
      !isOneRowSelected ||
      loading
    }
    item={currentItem}
  />;
  const reviews = <InventoryReviewsAction
    disabled={
      getGlobalDisabledState() ||
      !hasDataToDisplay ||
      !isOneRowSelected ||
      loading
    }
    item={currentItem}
  />;
  const copy = <CopyAction />;

  return (
    <Query query={getActiveOrderQuery}>
      {({ data, loading: activeOrderLoading }: any) => {
        const activeOrder = data && data.activeOrder;
        const activeOrderAccount =
          (activeOrder && activeOrder.Account) || {};
        const activeOrderSource = activeOrder || {};
        const activeOrderType =
          props.selectedOrderType || activeOrderSource.OrderTypeValue;

        const orderType = selectedOrderType || activeOrderType;
        const isBillAndHold = orderType === 'BHS';

        const onAddItemComplete =
          activeOrderSource &&
            activeOrderSource.Account &&
            activeOrderSource.Account.Level === 'J'
            ? () => {
              emitter.emit('pst-refetch');
            }
            : () => {
              emitter.emit('pst-check-refetch');
            };

        const addToOrder = <AddInventoryToOrderAction
          onItemAdded={onItemAdded}
          itemAddedStatus={itemAddedStatus || ''}
          moduleName={moduleName}
          selectedOrderType={selectedOrderType}
          selectedOrderDate={selectedOrderDate}
          disabled={
            getGlobalDisabledState() ||
            !isOneRowSelected ||
            loading ||
            activeOrderLoading ||
            activeOrderAccount.AcctNo === undefined ||
            isBillAndHold
          }
          item={currentItem}
          onItemUpdated={onItemUpdated}
          activeOrder={activeOrderSource}
          onComplete={onAddItemComplete}
          moduleRefetch={moduleRefetch}
        />;

        return (
          <>
            <DesktopView>
              <Row minHeight={props.minHeight}>
                <ActionsColumn>
                  <RefreshAction />
                  <ExportAction />
                </ActionsColumn>

                <ActionsColumn>
                  {copy}
                  <ColumnsAction />
                </ActionsColumn>

                <Separator />

                <ActionsColumn>
                  <SaveViewAction />
                </ActionsColumn>

                <Separator />

                <ActionsColumn>
                  {notes}
                  {reviews}
                </ActionsColumn>

                <ActionsColumn>
                  <StateSelectorAction disabled={!hasDataToDisplay || loading} />
                  <MonthSelectorAction disabled={!hasDataToDisplay || loading} />
                </ActionsColumn>

                <Separator />

                <ActionsColumn>
                  {restrictions}
                </ActionsColumn>

                <ActionsColumn>
                  {addToOrder}
                  <ClearFiltersAction clearInternalFilters={clearInternalFilters} disabled={loading} />
                </ActionsColumn>

                <ActionsColumn>
                  <MultiSortAction />
                </ActionsColumn>
              </Row>
            </DesktopView>
            <MobileView>
              {displayRowMenu &&
                <div className='actions-menu-top-section'>
                  <div style={{ fontWeight: 'bold', color: 'black' }}>{currentItem && currentItem.Description}</div>
                  <div style={{ fontStyle: 'italic' }}>{currentItem && currentItem.Restrictions}</div>
                </div>
              }
              <div className='action-menu-items'>
                <ActionsColumn>
                  <table>
                    {displayMenu &&
                      <tbody>
                        <tr>
                          <td><ExportAction /></td>
                        </tr>
                        <tr>
                          <td><SaveViewAction /></td>
                        </tr>
                      </tbody>
                    }
                    {displayRowMenu &&
                      <tbody>
                        <tr>
                          <td>{notes}</td>
                          <td>{reviews}</td>
                        </tr>
                        <tr>
                          <td>{addToOrder}</td>
                          <td>{copy}</td>
                        </tr>
                      </tbody>
                    }
                  </table>
                </ActionsColumn>
              </div>
            </MobileView>
          </>
        );
      }}
    </Query>
  );
};

export default ActionsOrganizerAccounts;
